/**
 * モーダルメニュー
 */
export default function modalMenu() {
  (function ($) {
    var $modalMenu = $('#modal-menu');
    var $siteMenuToggle = $('#site-menu-toggle');
    var $closeModalMenu = $('#close-modal-menu');

    $($siteMenuToggle).on('click', function () {
      $modalMenu.toggleClass('js-is-show');
    });

    $($closeModalMenu).on('click', function () {
      $modalMenu.removeClass('js-is-show');
    });
  })(jQuery);
}
